// extracted by mini-css-extract-plugin
export default {"orderInfo":"ProductInfoAllPeyk_orderInfo__542lJ","food":"ProductInfoAllPeyk_food__66itJ","count":"ProductInfoAllPeyk_count__xpLid"};